import React from "react";
import "./styles.scss";
import { Container, Row, Col } from "react-bootstrap";
// import { GrFormClose } from "react-icons/gr";

interface IProps {
  children: any;
}

const SubMenu = (props: IProps) => {
  return (
    <Container fluid className="sub-menu-workshop-view-wrapper px-0">
      {/* <GrFormClose className="close-icon" onClick={props.onHide} /> */}
      <Row>
        <Col xs={12}>{props.children}</Col>
      </Row>
    </Container>
  );
};

export default SubMenu;
